var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannerBox"},[_vm._l((_vm.items),function(item,i){return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.cur==i),expression:"cur==i"}],key:i,attrs:{"src":item}})}),_c('ul',{staticClass:"banner-circle"},_vm._l((_vm.items),function(v,i){return _c('li',{key:i,class:_vm.cur==i ?'selected':''})}),0)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }